const React = require('react');
const {FormWrapper} = require('../../../../../dumb/FormHandlers');

const InputUpload = require('../../../../../dumb/Upload/D');

const {
  apiKYCDocumentUpload,
  apiV2KycDocumentRemove,
} = require('../../../../../../api/admin/uploads');

const {AdminSubtitle} = require("../../../../../dumb/AdminHelpers/AdminLayout");

const {
  CompanyFields,
  UserRegistrationFooter,
  schemaCompany
} = require('../../../../../dumb/AdminHelpers/AdminUserRegistration');
const {
  AdminDocumentUploadOnboarding
} = require('../../../../../dumb/FormInputs');

const {apiAdminMerchantCompanyCreate, apiAdminMerchantCompanyUpdate, apiV2KycDocumentUpload} = require("../../../../../../api/admin/retailersCreate");

const {companyData} = require("../../../../../dumb/AdminHelpers/AdminUserRegistration/constants");

const {
  COMPANY_ADDRESS_FIELDS,
  COMPANY_OPERATING_FIELDS,
  getDefaultCompanyData
} = companyData;

module.exports = ({stepsData, stepsCompleted, emitNewUser, activeUserId, resetUserData, onFormResult, onNextStep, nextStepDisabled}) => {

  let data = {};

  if (stepsCompleted.company) {
    const companyData = stepsData.company || {};

    data = getDefaultCompanyData(companyData);

    const operating_equals_business = COMPANY_ADDRESS_FIELDS.every((key) => {
      const registerField = ['register', key].join('_');
      const operatingField = ['operating', key].join('_');
      return companyData[operatingField] === companyData[registerField];
    });

    data['operating_equals_business'] = operating_equals_business;

    if (!operating_equals_business) {
      COMPANY_OPERATING_FIELDS.forEach((key) => {
        data[key] = companyData[key] || '';
      })
    }

    data['business_registration_extract'] = companyData['business_registration_extract_doc'];
    data['business_operating_address'] = companyData['operating_address_doc'];
    data['share_holder_structure'] = companyData['structure_doc'];
  } else {
    data['company_name'] = (stepsData.account || {}).name;
  }

  return (
    <FormWrapper
      data={data}
      schema={schemaCompany}
      onSubmit={({
         operating_equals_business,
         business_registration_extract,
         business_operating_address,
         share_holder_structure,
         ...props
      }) => {
        const result = getDefaultCompanyData(props);

        if (operating_equals_business) {
          COMPANY_ADDRESS_FIELDS.forEach((key) => {
            const registerField = ['register', key].join('_');
            const operatingField = ['operating', key].join('_');

            result[operatingField] = props[registerField] || '';
          })
        } else {
          COMPANY_OPERATING_FIELDS.forEach((key) => {
            result[key] = props[key] || '';
          })
        }

        result['business_registration_extract_doc_id'] = (business_registration_extract || {}).id;
        result['operating_address_doc_id'] = (business_operating_address || {}).id;
        result['structure_doc_id'] = (share_holder_structure || {}).id;

        return (
          stepsCompleted.company
            ? apiAdminMerchantCompanyUpdate
            : apiAdminMerchantCompanyCreate
        )({id: activeUserId, ...result});
      }}
      onResult={!!stepsCompleted.company
        ? resetUserData
        : onFormResult
      }
    >
      {(formCtx) => (
        <>
          <CompanyFields
            account_id={activeUserId}
            formCtx={formCtx}
          />
          <UserRegistrationFooter
            submitBtnProps={{
              text: !stepsCompleted.company ? 'Save & Proceed' : 'Save',
              formCtx
            }}
            nextStepBtnProps={{
              onClick: onNextStep,
              disabled: nextStepDisabled
            }}
          />
        </>
      )}
    </FormWrapper>
  );
};
